import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

const baseRef = 'cep';
const route = {
  buscarEndereco: (cep: string) => `${baseRef}/${cep}`
}

@Injectable({
  providedIn: 'root'
})
export class CEPService {

  constructor(private apiService: ApiService) {

  }

  buscarEndereco(cep: string) {
    let params = new HttpParams().append('ignoreError','true');
    return this.apiService.get<any>(route.buscarEndereco(cep),params);
  }

  buscarEnderecoPublico(cep: string) {
    let params = new HttpParams().append('ignoreError','true');
    return this.apiService.get<any>(route.buscarEndereco(cep),params);
  }
}
